class AddToCartGuard {
  constructor(button) {
    if (button.dataset.guardBound) return;
    button.dataset.guardBound = 'true';

    this.button = button;
    this.guard = button.parentElement.querySelector('.add-to-cart-guard');

    const sectionId = button.closest('[data-section-id]')?.dataset.sectionId;
    this.variantPicker = sectionId
      ? document.querySelector(`variant-picker[data-section-id="${sectionId}"]`)
      : document.querySelector('variant-picker');

    this.guard?.addEventListener('click', this.handleGuardClick.bind(this));
    document.addEventListener('change', () => this.refresh());

    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['checked', 'value', 'class'],
      subtree: true,
    });

    this.refresh();
    setTimeout(() => this.refresh(), 500);
    setTimeout(() => this.refresh(), 1500);
  }

  get bundleBox() {
    return document.querySelector('.qvl-volume-box');
  }

  mainVariantSelected() {
    if (!this.variantPicker) return false;
    const groups = this.variantPicker.querySelectorAll('.variant-option');
    for (const group of groups) {
      const radios = group.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        if (![...radios].some((r) => r.checked)) return false;
        continue;
      }
      const select = group.querySelector('select');
      if (select && !select.value) return false;
    }
    return true;
  }

  bundleSelected() {
    return !!this.bundleBox?.querySelector('input[name="volume-tiers"]:checked');
  }

  allOptionsSelected() {
    return this.mainVariantSelected() || this.bundleSelected();
  }

  refresh() {
    const selected = this.allOptionsSelected();
    this.button.disabled = !selected;
    this.button.classList.toggle('add-to-cart-button--needs-selection', !selected);
    if (this.guard) this.guard.dataset.active = String(!selected);
  }

  handleGuardClick(event) {
    event.preventDefault();
    this.variantPicker?.classList.add('variant-picker--error');
    this.variantPicker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.SizeErrorToast?.show('Please select some product options before adding this product to cart.');
    setTimeout(() => this.variantPicker?.classList.remove('variant-picker--error'), 1200);
  }
}

document.querySelectorAll('[ref="addToCartButton"]').forEach((btn) => new AddToCartGuard(btn));











// class AddToCartGuard {
//   constructor(button) {
//     if (button.dataset.guardBound) return;
//     button.dataset.guardBound = 'true';

//     this.button = button;
//     const form = button.closest('form');
//     this.errorEl = form?.querySelector('[ref="addToCartTextError"]') || document.querySelector('[ref="addToCartTextError"]');
//     this.ensureMessageSpan();

//     const sectionId = button.closest('[data-section-id]')?.dataset.sectionId;
//     this.variantPicker = sectionId
//       ? document.querySelector(`variant-picker[data-section-id="${sectionId}"]`)
//       : document.querySelector('variant-picker');

//     document.addEventListener('change', () => this.refresh());

//     this.observer = new MutationObserver(() => this.refresh());
//     this.observer.observe(document.body, {
//       attributes: true,
//       attributeFilter: ['checked', 'value', 'class'],
//       subtree: true,
//     });

//     this.refresh();
//     setTimeout(() => this.refresh(), 500);
//     setTimeout(() => this.refresh(), 1500);
//   }

//   ensureMessageSpan() {
//     if (!this.errorEl) return;
//     if (!this.errorEl.querySelector('.product-form-text__error-message')) {
//       const span = document.createElement('span');
//       span.className = 'product-form-text__error-message';
//       span.textContent = 'Please select a size before adding to cart.';
//       this.errorEl.appendChild(span);
//     }
//   }

//   get bundleBox() {
//     return document.querySelector('.qvl-volume-box');
//   }

//   mainVariantSelected() {
//     if (!this.variantPicker) return false;
//     const groups = this.variantPicker.querySelectorAll('.variant-option');
//     for (const group of groups) {
//       const radios = group.querySelectorAll('input[type="radio"]');
//       if (radios.length) {
//         if (![...radios].some((r) => r.checked)) return false;
//         continue;
//       }
//       const select = group.querySelector('select');
//       if (select && !select.value) return false;
//     }
//     return true;
//   }

//   bundleSelected() {
//     return !!this.bundleBox?.querySelector('input[name="volume-tiers"]:checked');
//   }

//   allOptionsSelected() {
//     return this.mainVariantSelected() || this.bundleSelected();
//   }

//   refresh() {
//     const selected = this.allOptionsSelected();
//     this.button.disabled = !selected;
//     this.button.classList.toggle('add-to-cart-button--needs-selection', !selected);
//     this.errorEl?.classList.toggle('hidden', selected);
//   }
// }

// document.querySelectorAll('[ref="addToCartButton"]').forEach((btn) => new AddToCartGuard(btn));

